import * as Yup from 'yup'

export const getStepSchema = (currentStep: number, schemaArray: Yup.ObjectSchema<any>[]) => {
  return schemaArray[currentStep]
}
